module.exports = __webpack_public_path__ + "static/media/mainDog.eba4ba16.webp";